/* Importing the necessary libraries and files */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

/* Importing from the react-router-dom package. */
import { Link as RouterLink, useParams } from 'react-router-dom';

/* Importing the components from the Material UI library. */
import { Breadcrumbs, Button, Container, Link, Stack, Typography } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material/';

/* Importing the components from the components folder. */
import Page from '../../components/Page';
import DateTimePatientCards from '../../components/DateTimePatientCards';
import PatientSectionTabs from '../../sections/Patient/Patient.section.tabs';

/* Importing the formatPatient function from the utils folder. */
import { fPatient } from '../../utils/Patient/Patient.utils.format';

/**
 * Renders the PatientRegister component.
 * 
 * @returns {JSX.Element} The rendered PatientRegister component.
 */
export default function PatientRegister() {
  const params = useParams();

  /* Setting the initial state of the pagePatient object. */
  const [pagePatient, setPagePatient] = useState({});

  const { Patients } = useSelector((state) => state.patient);
  const currentPatient = Patients.find((el) => el.id === params.id);

  useEffect(() => {
    if (!currentPatient) return;
    setPagePatient(fPatient(currentPatient));
  }, [currentPatient]);

  return (
    <Page title="Patient Information">
      <Container maxWidth="none">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="column" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Patient Information
            </Typography>
            <Breadcrumbs aria-label="breadcrumb" mr={4}>
              <Link underline="hover" color="inherit" component={RouterLink} to="/patient/list">
                Patient
              </Link>
              <Typography color="text.primary">
                {pagePatient?.name_family}, {pagePatient?.name_given}
              </Typography>
            </Breadcrumbs>
          </Stack>

          <Button variant="contained" component={RouterLink} to={`/patient/edit/${params.id}`} startIcon={<EditIcon />}>
            Edit Patient Information
          </Button>
        </Stack>

        <DateTimePatientCards />

        <PatientSectionTabs patientID={params.id} />
      </Container>
    </Page>
  );
}
